import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award } from "lucide-react";
import api, { fileUrl } from "../lib/api";
import { SPONSOR_TIERS } from "../lib/data";

export const SponsorStamp = ({ s, size = "md" }) => {
  const dim = size === "lg" ? "w-40 h-40 md:w-52 md:h-52" : size === "sm" ? "w-24 h-24" : "w-32 h-32 md:w-36 md:h-36";
  const inner = (
    <div className={`stamp p-2 ${size === "lg" ? "hover:-translate-y-2" : "hover:-translate-y-1"} transition-transform`} data-testid={`sponsor-${s.id}`}>
      <div className="stamp-inner p-3 flex flex-col items-center bg-cream">
        <div className={`${dim} bg-cream border border-gold/50 flex items-center justify-center overflow-hidden`}>
          {s.logo_path ? (
            <img src={fileUrl(s.logo_path)} alt={s.name} loading="lazy" className="w-full h-full object-contain p-2" />
          ) : (
            <span className="numeral text-forest text-3xl text-center px-2">{s.name}</span>
          )}
        </div>
        <span className="font-display font-semibold text-forest text-center mt-2 leading-tight">{s.name}</span>
      </div>
    </div>
  );
  return s.website ? (
    <a href={s.website} target="_blank" rel="noreferrer">{inner}</a>
  ) : inner;
};

export const SponsorsPreview = () => {
  const [sponsors, setSponsors] = useState([]);
  useEffect(() => {
    api.get("/sponsors").then((r) => setSponsors(r.data)).catch(() => {});
  }, []);

  return (
    <section className="bg-forest text-cream py-20 md:py-28 relative" data-testid="sponsors-preview">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="eyebrow text-gold mb-3">Made Possible By</p>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl md:text-6xl tracking-tight">Our Sponsors</h2>
        </div>

        {sponsors.length === 0 ? (
          <div className="text-center max-w-xl mx-auto">
            <div className="inline-flex flex-col items-center gap-4 border-2 border-dashed border-gold/60 px-10 py-12">
              <Award size={48} className="text-gold" />
              <p className="tagline-italic text-gold-light text-2xl">This spot is waiting for you.</p>
              <p className="font-mono text-sm text-cream/70">Be among the first to support Pak Fest 2026.</p>
              <a href="/#get-involved" className="btn-rust px-6 py-3 text-sm" data-testid="preview-become-sponsor">Become a Sponsor</a>
            </div>
          </div>
        ) : (
          <>
            {SPONSOR_TIERS.map((tier) => {
              const list = sponsors.filter((s) => s.tier === tier.key);
              if (!list.length) return null;
              return (
                <div key={tier.key} className="mb-10">
                  <div className="flex items-center gap-4 mb-6">
                    <span className="eyebrow text-gold whitespace-nowrap">{tier.label}</span>
                    <div className="h-px bg-gold/40 flex-1" />
                  </div>
                  <div className="flex flex-wrap justify-center gap-6">
                    {list.map((s) => <SponsorStamp key={s.id} s={s} size={tier.key === "Title" ? "lg" : "md"} />)}
                  </div>
                </div>
              );
            })}
            <div className="text-center mt-10">
              <Link to="/sponsors" className="btn-forest px-8 py-3 text-sm border-cream shadow-none hover:bg-forest-light" data-testid="view-all-sponsors">
                View All Sponsors
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  );
};
